import { css } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import { useStatsPermission, useStatsZeroState } from '../../lib/hooks'
import { StatsContainer } from '../StatsContainer'
import { ReaderInsight } from '../shared'
import { StatsHeader } from '../stats_header/StatsHeader'
import { AuthorsGrid } from './AuthorsGrid'
import { AuthorsShareButton } from './AuthorsShareButton'
import { StatsHeaderTitle } from '../stats_header'

export const AuthorStats = () => {
  const [theme, yearStatus, year] = useStats((s) => [
    s.theme,
    s.yearStatus,
    s.year,
  ])
  const zeroState = useStatsZeroState('authors')
  const { isStatsOwner } = useStatsPermission()

  const getContent = () => {
    if (zeroState && isStatsOwner) {
      if (yearStatus !== 'current') return null

      return (
        <ReaderInsight
          data-testid="reader-insight-authors"
          label="How to get started"
          text="Add 2 or more books written by the same author to your Finished list,
        and we’ll highlight your most read authors here."
        />
      )
    }

    return !zeroState ? <AuthorsGrid data-testid="stats-authors-grid" /> : null
  }

  return (
    <StatsContainer
      id="authors"
      data-testid="stats-authors"
      backgroundColor={theme.bg100}
      empty={zeroState}
    >
      <StatsHeader actions={zeroState ? null : <AuthorsShareButton />}>
        <StatsHeaderTitle
          top={`Most read${!zeroState ? '' : ' authors'}`}
          middle={!zeroState ? 'Authors' : 'None'}
          bottom={
            !zeroState ? (
              <span
                className={css`
                  opacity: 0.5;
                `}
              >
                {yearStatus === 'past' ? `in ${year}` : 'so far this year'}
              </span>
            ) : (
              'yet...'
            )
          }
          infoButton={{
            text: 'Add 2 or more books written by the same author to your Finished list, and we’ll highlight your most read authors here.',
          }}
        />
      </StatsHeader>
      {getContent()}
    </StatsContainer>
  )
}
